import { Component, OnInit } from '@angular/core';
import { Course } from 'src/app/models/course';
import { Stream } from 'src/app/models/stream';
import { TutorService } from 'src/app/services/tutor.service';
import { CourseService } from 'src/app/services/course.service';
import { StreamService } from 'src/app/services/stream.service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FilterService } from 'src/app/services/filter.service';
import { RoleFilters } from 'src/app/models/roleFilters';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Tutor } from 'src/app/models/tutor';

@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: ['./tutor.component.scss']
})
export class TutorComponent implements OnInit {
  public tutorId;
  public loadingTutor:boolean=true;
  public loadingCourses:boolean=true;
  public loadingSeries:boolean=true;
  public tutor;
  public courses:Course[];
  public series:Stream[];
  public tutorImagePath:string;
  public blurb:string;
  public roleFilters: RoleFilters;
  public loggedIn:boolean=false;
  public breadcrumbLinks=[{routerLink:'/tutors', label: 'Lecturers'}];
  public thisPage:string = '';

  constructor(
    private _tutor: TutorService,
    private _course: CourseService,
    private _stream: StreamService,
    private _route: ActivatedRoute,
    private _filter: FilterService,
    private _auth: AuthenticationService
  ) {
    this._auth.loggedIn.subscribe(res=>{
      this.loggedIn=res;
    });
    this.tutorId=this._route.snapshot.paramMap.get('id');
    this.tutorImagePath=environment.apiEndpoint+'/storage/tutors/';
    this._filter.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
        this._course.getTutorCourses(this.tutorId, this.roleFilters).subscribe(
          res=>{
            this.courses=res;
          }
        );
      }
    );
  }

  ngOnInit() {
    forkJoin(
      this._tutor.getTutor(this.tutorId),
      this._course.getTutorCourses(this.tutorId, this.roleFilters, this.loggedIn),
      this._stream.getTutorStreams(this.tutorId, this.loggedIn)
    ).subscribe(
      data=>{
        this.tutor=new Tutor(data[0]);
        if(!this.tutor.image) this.tutor.image='Central_Lecturers_960_Circles_default.png';
        this.loadingTutor=false;
        this.courses=data[1];
        this.loadingCourses=false;
        this.series=data[2];
        this.loadingSeries=false;
        this.thisPage=this.tutor.name;
      }
    );
  }

}
